import React from 'react';
import { withStyles, withTheme } from '@material-ui/styles';

const useStyles = theme => ({
    main: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        transform: "scale(4)",
        position: "absolute",   
        top: "38%",   
        left: "50%"
    },
    circularLoader: { 
        animation: '$isRotating 1s infinite',
        borderRadius: '50%',
        width: '8px',
        height: '8px',
        border: '0.2px solid #e5e5e5',
        borderTopColor: '#1351b4'
    },
    loaderText: {
        color: '#1351b4',
        fontSize: '7px'
    },
    '@keyframes isRotating': {
        to: {
            transform: 'rotate(1turn)', 
        },
    }

})

const LoadingCircular = props => {
    
  let { classes } = props;

  return (
    <div id="circularLoader" className={classes.main}>
      <div className={classes.circularLoader}></div>      
    </div>
  )
}

export default (withStyles(useStyles)(withTheme(LoadingCircular)));
